<script>
import Layout from '@layouts/main'
import HeaderPage from '@/src/components/register/header-page.vue'
import UnidadeForm from '@/src/components/forms/unidade-form.vue'
import Table from '@/src/components/tables/table-register.vue'

import alertMixin from '@/src/mixins/alertMixin'
import unidadeMixin from '@/src/mixins/unidadeMixin'

export default {
  components: {
    Layout,
    HeaderPage,
    UnidadeForm,
    Table,
  },
  mixins: [alertMixin, unidadeMixin],
  data() {
    return {
      pageTitles: {
        title: 'Unidade',
        subtitle: 'Gerenciamento de unidades aqui.',
      },
      unidadeEdit: {
        codigo: 0,
      },
      unidades: [],
      formOpen: true,
      isLoading: false,
      userType: this.$store.state.auth.currentUser.type,
      token: this.$store.state.auth.access_token,
    }
  },
  mounted() {
    this.listando()
  },

  methods: {
    listando() {
      this.isLoading = true
      this.loadUnidades()
        .then((unidades) => {
          this.unidades = unidades
          this.isLoading = false
        })
        .catch((error) => this.errorMessage(error))
    },
    abrirForm() {
      if (this.formOpen === true) {
        this.formOpen = false
      } else {
        this.formOpen = true
        this.formsubmit = false
        this.unidadeEdit = {
          codigo: 0,
        }
      }
    },
    async onDelete(id) {
      this.isLoading = true
      try {
        await this.deleteUnidade(id)
        this.successMessage('Deletado com sucesso')
        this.listando()
      } catch (error) {
        this.errorMessage(error)
      }
    },
    async onSubmit() {
      try {
        if (!this.verificaDuplicidade(this.unidades, this.unidadeEdit)) {
          this.isLoading = true
          await this.registerUnidade(this.unidadeEdit)
          this.successMessage('Cadastrado com sucesso')
          this.abrirForm()
          this.listando()
          this.isLoading = false
        } else {
          this.errorMessage('Nome da unidade já Existe!')
        }
      } catch (error) {
        this.errorMessage(error)
        this.isLoading = false
      }
    },
    edit(item) {
      this.unidadeEdit = item
      this.abrirForm()
    },
    async onEdit() {
      try {
        if (!this.verificaDuplicidade(this.unidades, this.unidadeEdit)) {
          this.isLoading = true
          await this.editUnidade(this.unidadeEdit._id, this.unidadeEdit)
          this.abrirForm()
          this.listando()
          this.isLoading = false
        } else {
          this.errorMessage('Nome da unidade já Existe!')
        }
      } catch (error) {
        this.errorMessage(error)
      }
    },
    verificaDuplicidade(lista, nome) {
      for (let nomeLista of lista) {
        if (
          nomeLista.unidade.toLowerCase().trim() ===
            nome.unidade.toLowerCase().trim() &&
          nome.codigo !== nomeLista.codigo
        ) {
          return true
        }
      }
    },
  },
}
</script>
<template>
  <Layout :is-loading="isLoading">
    <div class="bloco">
      <HeaderPage
        :form-open="formOpen"
        :page-titles="pageTitles"
        @onClick="abrirForm"
      />
      <div>
        <div v-if="formOpen">
          <Table
            :form-open="formOpen"
            :tables-fields="unidadesFields"
            :table-items="unidades"
            @onEdit="edit"
            @onDelete="onDelete"
          />
        </div>
        <div v-else>
          <UnidadeForm
            :unidade-edit="unidadeEdit"
            :on-submit="onSubmit"
            :on-edit="onEdit"
            :codigo="unidadeEdit.codigo"
          />
        </div>
      </div>

      <div class="borda"></div>
    </div>
  </Layout>
</template>
<style src="../style.scss" lang="scss"></style>
